(function (window, undefined) {

  const {acpv: {Map} = {}} = window;
  
  if (Map === undefined) {
    throw new Error(`
      Missing dependency Map.
      Please include map.js before this file.
    `);
  }

  class Storage {
    
    get(key) {
      return Cookies.getJSON(key);
    }
  
    put(key, value) {
      Cookies.set(key, value);
      return value;
    }
  }

  class SessionStorage {
    enabled = true;

    constructor() {
      try {
        sessionStorage.setItem('test', null);
        sessionStorage.removeItem('test');
      } catch (exception) {
        this.enabled = false;
      }
    }

    get(key) {
      if (!this.enabled) {
        return undefined;
      }

      const value = sessionStorage.getItem(key);

      if (value === null) {
        return undefined; // to be consistent with Cookies client
      }

      return JSON.parse(value);
    }
  
    put(key, value) {
      if (this.enabled) {
        sessionStorage.setItem(key, JSON.stringify(value));
      }

      return value;
    }
  }

  class CompareVehicles extends Map {
    
    constructor(Storage) {
      super(Storage.get('acpv.inventory.compareVehicles'));
  
      this.on('change', () => {
        Storage.put('acpv.inventory.compareVehicles', this.toObject());
      });
    }
  }
  
  class SavedVehicles extends Map {
    
    constructor(Storage) {
      super(Storage.get('acpv.inventory.savedVehicles'));
  
      this.on('change', () => {
        Storage.put('acpv.inventory.savedVehicles', this.toObject());
      });
    }
  }

  window.acpv.Storage = new Storage();
  window.acpv.SessionStorage = new SessionStorage();
  window.acpv.SavedVehicles = new SavedVehicles(window.acpv.Storage);
  window.acpv.CompareVehicles = new CompareVehicles(window.acpv.SessionStorage);

})(window)
